import { sendUtagEvent } from '../../core/analytics/utag_events'
import { deleteCookies, setCookies } from '../../utils/cookie_manager'
import { getCleanedString } from '../../utils/utilities'

export function initializeUtagEvents(eventLabel) {
  sendUtagEvent({
    data: {
      event_name: 'pre_lead',
      event_cat: 'lead',
      event_act: 'pre lead',
      event_lbl: getCleanedString(eventLabel),
      event_purpose: 'loyalty',
      event_structure: 'impression',
    },
  })
}
export function initializeUtagEventsSucces() {  
  sendUtagEvent({
    data: {
      event_name: 'real_lead',
      event_cat: 'lead',
      event_act: 'real lead',
      event_lbl: 'email',
      event_purpose: 'loyalty',
      event_structure: 'impression',
    },
  })
  setTimeout(() => {
    const cookie = { name: 'register_success', value: false, expires: '-1' }
    if (typeof IB === 'undefined' || typeof IB.cookieManager === 'undefined') {
      deleteCookies([cookie])
    } else {
      setCookies([cookie])
    }
    console.log('🚀 ~ initializeUtagEventsSucces ~ cookie:', cookie)
  }, 500)  
}
